import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export class ReadingService {
	public static readingSave(input: any) {
		return input.reading.readingId >= 0 ?
			Http.axios().put('/api/Reading/update', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				})
			:
			Http.axios().post('/api/Reading/add', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				});
	}

	public static readingGetByFilter(input: any) {
		var obj = JSON.stringify(input);
		return Http.axios().post('/api/Reading/getbyfilter', obj, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingGetDetail(id: any) {
		return Http.axios().get('/api/Reading/details/' + id, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingDelete(input: any) {
		return Http.axios().delete('/api/Reading/delete/' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static readingTextUpdate(input: number) {
		return Http.axios().put('api/Reading/updateredingtext', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => { return res; })
			.catch((e: any) => {return e.response;});
	}

	public static radingTitleGetExcludeByBible(input: any) {
		return Http.axios().post('/api/Reading/getradingtitleexcludebybible', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {return res;})
			.catch((e: { response: any; }) => {return e.response;}) as AxiosPromise<any>;
	}	
}